import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { "data-cy": "invoice-list-row" };
import OrderDocument from "@/model/OrderDocument";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrderInvoiceListRow',
    props: {
        invoice: { type: OrderDocument, required: true }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                _createElementVNode("td", null, _toDisplayString(__props.invoice.fileName), 1)
            ]));
        };
    }
});
